import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoInstalacion/editTipoInstalacion`, method: 'POST', body: values, token: token})
}
